



   <div id="page-container" class="main-content-boxed">
      <!-- Main Container -->
      <main id="main-container">
          <!-- Page Content -->
          <div class="bg-gd-duskX">
              <div class="hero-static content content-full bg-white invisibles" data-toggle="appears">





                        <!-- Header -->
                        <div class="py-30 px-5 text-center">

                            <h1 class="h2 font-w700 mt-50 mb-10">Please Sign In</h1>
                            <h2 class="h4 font-w400 text-muted mb-0"></h2>
                        </div>
                        <!-- END Header -->



  <!-- Sign In Form -->
  <div class="row justify-content-center px-5">
      <div class="col-sm-8 col-md-6 col-xl-4">
          <!-- jQuery Validation (.js-validation-signin class is initialized in js/pages/op_auth_signin.js) -->
          <!-- For more examples you can check out https://github.com/jzaefferer/jquery-validation -->



          <div id="divLoginWait"  *ngIf="loginStatus === 1">One moment please...</div>
          <div *ngIf="loginStatus === 0">


          <div style='color: brown; padding: 5px; font-weight: bold' *ngIf="loginError != ''">{{loginError}}</div>


            <form >
                <div class="form-group row">
                    <div class="col-12">
                        <div class="form-material">
                            <input type="text" class="form-control" id="email" name="login-username"  [(ngModel)]="email" required tabindex="1">
                            <label for="login-username">Username</label>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-12">
                        <div class="form-material">
                            <input type="password" class="form-control" id="login-password" name="login-password" [(ngModel)]="password"  tabindex="2" >
                            <label for="login-password">Password</label>
                        </div>
                    </div>
                </div>
                <div class="form-group row gutters-tiny">
                    <div class="col-12 mb-10">
                        <a class="btn btn-block btn-hero btn-noborder btn-rounded btn-alt-primary" (click)="postLogin()" tabindex="3" >
                            <i class="si si-login mr-10"></i> Sign In
                        </a>
                    </div>
                    <div class="col-sm-12 mb-5">
                        <a class="btn btn-block btn-noborder btn-rounded btn-alt-secondary" routerLink="/register" tabindex="4">
                            <i class="fa fa-plus text-muted mr-5"></i> New Account
                        </a>
                    </div>
          
                </div>
            </form>


          </div>

      </div>
  </div>
  <!-- END Sign In Form -->


















              </div>
          </div>
      </main>
    </div>





